export default __webpack_public_path__ + "static/media/slotselect-inactive.bfd76577.svg";